import { SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const pageBoxSx: SxProps<Theme> = {
	pt: 4,
	pr: 4,
	pb: 4,
	pl: '24px',
	flex: 1,
	width: '100%',
	boxSizing: 'border-box',
	backgroundColor: '#F9FAFB',
	display: 'flex',
	flexDirection: 'column',
	minHeight: 'calc(100vh - 56px)'
};

export const headerRowSx: SxProps<Theme> = {
	height: '51.5px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	pt: '24px',
	pl: 0,
	pr: 0,
	opacity: 1,
};

export const leftTextSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
};

export const createButtonWrapperSx: SxProps<Theme> = { display: 'flex', gap: 2, alignItems: 'center' };

export const controlsRowSx: SxProps<Theme> = {
	display: 'flex',
	gap: '20px',
	alignItems: 'center',
	height: '35px',
	mt: '24px',
	pl: 0,
	opacity: 1,
};

export const selectSx: SxProps<Theme> = {
	height: '36px',
	color: '#6B7280',
	width: '100%',
	boxSizing: 'border-box',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 400,
	fontStyle: 'normal',
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
	'& .MuiSelect-select': {
		display: 'flex',
		alignItems: 'center',
		height: '36px',
		color: '#6B7280',
	},
};

export const menuItemSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 400,
	fontStyle: 'normal',
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
};

export const selectFormSx: SystemStyleObject<Theme> = {
	height: '36px',
	display: 'flex',
	alignItems: 'center',
	width: '180px',
	justifyContent: 'space-between',
	pt: '8px',
	// pr: '15px',
	// pb: '8px',
	backgroundColor: 'transparent',
};

export const allSelectCombinedSx: SystemStyleObject<Theme> = {
	...(selectFormSx as SystemStyleObject<Theme>),
	justifyContent:'flex-end',
};

export const pageTitleSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 700,
	fontStyle: 'normal',
	fontSize: '20px',
	lineHeight: '30px',
	letterSpacing: '-0.45px',
};

export const taglineSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 400,
	fontStyle: 'normal',
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
	color: '#6B7280',
};

export const nodeDetailsSx: SxProps<Theme> = {
	borderRadius: '14px',
	border: '1px solid rgba(0,0,0,0.06)',
	opacity: 1,
	display: 'block',
	width: '100%',
	maxWidth: '1100px',
	alignSelf: 'flex-start',
	maxHeight: 'calc(100vh - 260px)',
	overflowY: 'auto',
};

export const createButtonSx: SxProps<Theme> = {
	width: '123px',
	height: '36px',
	borderRadius: '10px',
	border: '1px solid #E5E7EB',
	backgroundColor: 'transparent',
	color: '#111827',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '8px',
	pt: '8px',
	pr: '12px',
	pb: '8px',
	pl: '12px',
	opacity: 1,
	textTransform: 'none',
};

export const bulkButtonSx: SxProps<Theme> = {
	width: '189.515625px',
	height: '37.5px',
	borderRadius: '10px',
	border: '1px solid #E5E7EB',
	backgroundColor: 'transparent',
	color: '#111827',
	textTransform: 'none',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
		fontFamily: 'Inter, Arial, sans-serif',
		fontWeight: 500,
		fontStyle: 'normal',
		fontSize: '13px',
		lineHeight: '19.5px',
		letterSpacing: '-0.08px',
	textAlign: 'center',
};

export const avatarSx: SxProps<Theme> = {
	width: '32px',
	height: '32px',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 700,
	fontSize: '12px',
	borderRadius: '16777200px',
	pr: '0.01px',
	backgroundColor: '#143133',
};

export const tableHeadSx: SxProps<Theme> = {
	backgroundColor: '#F9FAFB',
	height: '40px',
	minHeight: '40px',
	maxHeight: '40px',
	borderBottom: '1px solid rgba(0,0,0,0.06)',
};

export const tableHeaderTextSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 600,
	fontStyle: 'normal',
	fontSize: '11px',
	lineHeight: '16.5px',
	letterSpacing: '0.06px',
};

export const supervisorSx: SxProps<Theme> = {
	borderRadius: '16777200px',
	backgroundColor: '#F5F3FF',
	color: '#556768',
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '11px',
	lineHeight: '16.5px',
	letterSpacing: '0.06px',
	px: 1,
	height: '24.5px',
};

export const dispatcherSx: SxProps<Theme> = {
	borderRadius: '16777200px',
	backgroundColor: '#EFF6FF',
	color: '#39A9B1',
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '11px',
	lineHeight: '16.5px',
	letterSpacing: '0.06px',
	px: 1,
	height: '24.5px',
};


export const addAccountSX: SxProps<Theme> = {
	width: '149px',
	height: '35.5px',
	borderRadius: '10px',
	backgroundColor: '#39A9B1',
	color: '#FFFFFF',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '8px',
	pt: '8px',
	pr: '12px',
	pb: '8px',
	pl: '12px',
		opacity: 1,
		textTransform: 'none',
		fontFamily: 'Inter, Arial, sans-serif',
		fontWeight: 500,
		fontSize: '13px',
		lineHeight: '19.5px',
		letterSpacing: '-0.08px',
		textAlign: 'center',
		'&:hover': { backgroundColor: '#39A9B1' },
};

// Add Guard page tokens
export const sectionPaperSx: SxProps<Theme> = {
	borderRadius: '14px',
	border: '1px solid #E5E7EB',
	backgroundColor: '#FFFFFF',
	px: '21px',
	py: '21px',
	pb: '1px',
	width: '100%',
	maxWidth: '900px',
	boxSizing: 'border-box',
};

	export const personalSectionSx: SxProps<Theme> = {
		height: '235px',
	};

	export const identitySectionSx: SxProps<Theme> = {
		height: '450px',
	};

export const avatarLargeSx: SxProps<Theme> = {
	width: '64px',
	height: '64px',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 700,
	fontSize: '18px',
	borderRadius: '16777200px',
	backgroundColor: '#143133',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: '#FFFFFF',
	border: '2px solid #E5E7EB',
};

export const avatarBadgeSx: SxProps<Theme> = {
	position: 'absolute',
	width: '24px',
	height: '24px',
	borderRadius: '9999px',
	backgroundColor: '#39A9B1',
	border: '2px solid #FFFFFF',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	right: 0,
	bottom: 0,
};

export const uploadTextSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '11px',
	lineHeight: '16px',
	letterSpacing: '0.06px',
	color: '#39A9B1',
	textAlign: 'center',
};

export const labelBoldSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '13px',
	lineHeight: '20px',
	color: '#374151',
};

export const formInputSx: SxProps<Theme> = {
	'& .MuiInputBase-root': {
		height: '41.5px',
		borderRadius: '10px',
		paddingTop: '10px',
		paddingBottom: '10px',
		paddingLeft: '12px',
		paddingRight: '12px',
	},
};

export const saveButtonSx: SxProps<Theme> = {
	width: '67px',
	height: '36px',
	borderRadius: '10px',
	backgroundColor: '#39A9B1',
	color: '#FFFFFF',
	textTransform: 'none',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
};

export const cancelButtonSx: SxProps<Theme> = {
	width: '67px',
	height: '36px',
	borderRadius: '10px',
	border: '1px solid #E5E7EB',
	backgroundColor: 'transparent',
	color: '#374151',
	textTransform: 'none',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
};

// Bulk import modal styles
export const bulkModalContainerSx: SxProps<Theme> = {
	position: 'absolute',
	width: '520px',
	height: '440.296875px',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	borderRadius: '16px',
	backgroundColor: '#FFFFFF',
	boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
	outline: 'none',
	display: 'flex',
	flexDirection: 'column',
};

export const bulkModalHeaderSx: SxProps<Theme> = {
	height: '65px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	px: '24px',
	borderBottom: '1px solid rgba(0,0,0,0.06)',
};

export const bulkModalTitleSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 600,
	fontSize: '16px',
	lineHeight: '24px',
	letterSpacing: '-0.31px',
};

export const bulkModalCloseSx: SxProps<Theme> = {
	width: '16px',
	height: '16px',
	minWidth: '16px',
	padding: 0,
};

export const bulkModalBodySx: SxProps<Theme> = {
	px: '24px',
	pt: '16px',
	pb: '24px',
	display: 'flex',
	flexDirection: 'column',
	gap: 2,
};

export const bulkTemplateBoxSx: SxProps<Theme> = {
	width: '472px',
	height: '113px',
	borderRadius: '14px',
	border: '1px solid rgba(0,0,0,0.06)',
	backgroundColor: '#F9FAFB',
	px: 2,
	py: 1.5,
	display: 'flex',
	flexDirection: 'column',
	gap: 1,
};

export const bulkFileDropSx: SxProps<Theme> = {
	width: '472px',
	height: '116px',
	borderRadius: '8px',
	border: '1px dashed rgba(0,0,0,0.12)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	color: '#6B7280',
	cursor: 'pointer',
	backgroundColor: '#FFFFFF',
};

export const bulkFileIconSx: SxProps<Theme> = {
	width: '20px',
	height: '20px',
	mt: '6px',
};

export const bulkSelectTextSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
	textAlign: 'center',
};

export const bulkBrowseTextSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '11px',
	lineHeight: '16.5px',
	letterSpacing: '0.06px',
	textAlign: 'center',
	color: '#9CA3AF',
};

export const bulkTemplateFieldsSx: SxProps<Theme> = {
	fontFamily: 'Menlo, monospace',
	fontWeight: 400,
	fontSize: '12px',
	lineHeight: '18px',
	letterSpacing: '0px',
	color: '#39A9B1',
};

export const bulkDownloadTextSx: SxProps<Theme> = {
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '12px',
	lineHeight: '18px',
	letterSpacing: '0px',
	color: '#39A9B1',
	cursor: 'pointer',
};

export const bulkModalFooterSx: SxProps<Theme> = {
	display: 'flex',
	justifyContent: 'flex-end',
	gap: 2,
	px: '24px',
	pb: '20px',
};

export const bulkModalCancelSx: SxProps<Theme> = {
	width: '76.4921875px',
	height: '37.5px',
	borderRadius: '10px',
	color: '#111827',
	textTransform: 'none',
	border: '1px solid rgba(0,0,0,0.08)',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
	textAlign: 'center',
};

export const bulkModalImportSx: SxProps<Theme> = {
	width: '119.34375px',
	height: '37.5px',
	borderRadius: '10px',
	backgroundColor: '#39A9B1',
	color: '#FFFFFF',
	textTransform: 'none',
	fontFamily: 'Inter, Arial, sans-serif',
	fontWeight: 500,
	fontSize: '13px',
	lineHeight: '19.5px',
	letterSpacing: '-0.08px',
	textAlign: 'center',
};